import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpUserEvent } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, of } from 'rxjs';
import { retry, catchError, map, filter, take, switchMap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})

export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private _utilService: UtilService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(catchError(err => {
          if (err instanceof HttpErrorResponse) {
            //console.log(err);

            if ((<HttpErrorResponse>err).status === 401) { // Expired Token
              this._utilService.showToast('Session expired. Please login again.', '', 'warning', {});

              this._utilService.retailerLogout();

              return;
            } else if ((<HttpErrorResponse>err).status === 400) { // Bad Request
              this._utilService.showToast(err.error.message, '', 'error', { preventDuplicates: true, preventOpenDuplicates: true });
            } else if ((<HttpErrorResponse>err).status === 500) { // Internal Server Error
              this._utilService.showToast(environment.apiErrorMessage, '', 'error', { preventDuplicates: true, preventOpenDuplicates: true });
            }
          }

          return throwError(err);
        })
      );
  }


}
